export default "__VITE_ASSET__CWV5Z$6o__"